/**
 * Sets document.documentElement[data-active-panel] from the index panel whose band
 * best overlaps a focal line (viewport-relative). Requires [data-odx-signal-panel] on
 * home banner, magnetic vault, and shop section roots.
 */
(function () {
  'use strict';

  function refresh() {
    var nodes = document.querySelectorAll('[data-odx-signal-panel]');
    if (!nodes.length) return;

    var vh = window.innerHeight || 0;
    if (vh <= 0) return;

    var focal = vh * 0.42;
    var bestId = '';
    var bestScore = -1;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var id = el.getAttribute('data-odx-signal-panel');
      if (!id) continue;

      var rect = el.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= vh) continue;

      var visibleTop = Math.max(rect.top, 0);
      var visibleBottom = Math.min(rect.bottom, vh);
      var visible = Math.max(0, visibleBottom - visibleTop);
      if (visible <= 0) continue;

      var mid = (rect.top + rect.bottom) / 2;
      var dist = Math.abs(mid - focal) / vh;
      var score = visible * (1.15 - dist);

      if (score > bestScore) {
        bestScore = score;
        bestId = id;
      }
    }

    if (bestId) {
      document.documentElement.setAttribute('data-active-panel', bestId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh);
})();
